// Import Actions
import { SET_VIDEO_TOKEN, ADD_USER_TRACK, REMOVE_USER_TRACK } from './VideoActions';
import { LOGOUT_USER } from '../User/AuthActions';

// Initial State
const initialState = {
    token: null,
    usersTracks: [], // [{user: 'user1', tracks: [{sid: '...', name: 'camera', kind: 'video'}]}]
};

const VideoReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_VIDEO_TOKEN:
            return {
                ...state,
                token: action.token,
            };

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

/* Selectors */

// Export Reducer
export default VideoReducer;
